import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import Login from "./routes/Login";
import Progress from "./routes/Progress";
import WeekWords from "./routes/WeekWords";
import Settings from "./routes/Settings";
import Terms from "./routes/Terms";
import Privacy from "./routes/Privacy";
import ErrorBoundary from "./components/ErrorBoundary";
import SpiralIcon from "./components/SpiralIcon";
import { getCurrentUser, type CurrentUser } from "./lib/api";

/** undefined = 判定中、null = 未ログイン */
type AuthState = CurrentUser | null | undefined;

export default function App() {
  const [user, setUser] = useState<AuthState>(undefined);

  useEffect(() => {
    // 失敗（サーバー未起動など）は未ログイン扱いにしてログイン画面を出す
    getCurrentUser()
      .then(setUser)
      .catch(() => setUser(null));
  }, []);

  if (user === undefined) {
    return (
      <div
        className="bg-slate-50 dark:bg-[#020617] flex items-center justify-center"
        style={{ minHeight: "100dvh" }}
      >
        <SpiralIcon className="h-12 w-auto text-blue-600 dark:text-blue-400 animate-pulse" />
      </div>
    );
  }

  return (
    <ErrorBoundary>
      {user ? (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/progress/words/:week" element={<WeekWords />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      ) : (
        <Routes>
          {/* 規約とプライバシーはログイン前でも読めるようにしておく */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Login />} />
        </Routes>
      )}
    </ErrorBoundary>
  );
}
